/**
 * PtSafT API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { generatePtSaftReport } from "../generated/pt-saf-t/pt-saf-t";

import { wrapMethod } from "./utils";

export const ptSafT = {
  /** @see generatePtSaftReport */
  generateReport: wrapMethod(generatePtSaftReport),
} as const;

export type PtSafTApi = typeof ptSafT;
